import classNames from 'classnames'

import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { MANAGEMENT_VIEW_OPTIONS } from '@apps-common/config/management-view'
import { ModalDismiss } from '@apps-common/config/modal'
import { useManagementViewStore } from '@apps-common/stores'

export const ManagementViewSelectModal = ({
  onDismiss
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
}) => {
  const { open, setOpen, value, setValue } = useManagementViewStore()

  return (
    <ModalContainer innerClasses='!h-auto !min-h-0 !min-w-auto sm:!w-auto'>
      <ModalHeaderContainer>
        <div className='flex items-center justify-between'>
          <ModalHeader subtitle='Selection' title='Management' subtitleClasses='capitalize' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='relative !pt-[90px] !pb-[30px] sm:!pb-[20px]'>
        <div className='grid grid-cols-2 gap-[16px] pb-[10px]'>
          {MANAGEMENT_VIEW_OPTIONS.map((o) => (
            <button
              key={`management-view-${o.label}`}
              type='button'
              aria-label={`Select Management ${o.label}`}
              className={classNames(
                'jost w-full rounded-xl px-3 py-3',
                o.value === value && 'bg-brand text-on-brand ring-2 ring-brand',
                o.value !== value && 'action-brand'
                // o.value === MANAGEMENT_REPORTING.value && 'col-span-2'
              )}
              onClick={() => {
                setValue(o.value as string)
                onDismiss(null, ModalDismiss.Confirm)
              }}
            >
              {o.label}
            </button>
          ))}
        </div>
      </ModalBody>
    </ModalContainer>
  )
}
